export class User {
  constructor(
      public readonly id: string,
      public readonly fullName?: string,
      public readonly email?: string,
  ) {
  }
}
